const services = [
  {
    icon: 'ri-hospital-line',
    title: 'Rehabilitación Dental',
    desc: 'Restauramos la función y estética de tu sonrisa con tratamientos integrales adaptados a cada caso clínico.',
    color: 'from-[#3A86FF]/15 to-[#0A2540]/10',
    iconColor: 'text-[#3A86FF]',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Limpieza y Prevención',
    desc: 'Profilaxis profesional y tratamientos preventivos para mantener tu salud bucal al más alto nivel.',
    color: 'from-emerald-500/15 to-emerald-900/10',
    iconColor: 'text-emerald-500',
  },
  {
    icon: 'ri-magic-line',
    title: 'Estética Dental',
    desc: 'Blanqueamiento, carillas y diseño de sonrisa para lograr la transformación estética que siempre soñaste.',
    color: 'from-violet-500/15 to-violet-900/10',
    iconColor: 'text-violet-500',
  },
  {
    icon: 'ri-award-line',
    title: 'Prótesis y Coronas',
    desc: 'Soluciones protésicas de alta precisión: coronas, puentes y prótesis removibles con materiales premium.',
    color: 'from-amber-500/15 to-amber-900/10',
    iconColor: 'text-amber-500',
  },
  {
    icon: 'ri-align-justify',
    title: 'Ortodoncia',
    desc: 'Alineación dental con brackets tradicionales o alineadores transparentes para una mordida perfecta.',
    color: 'from-rose-500/15 to-rose-900/10',
    iconColor: 'text-rose-500',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-28 bg-[#f7f9fc] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16 scroll-animate">
          <span className="inline-block text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-3">
            Lo que ofrecemos
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0A2540] mb-5">
            Nuestros{' '}
            <span className="bg-gradient-to-r from-[#3A86FF] to-[#0A2540] bg-clip-text text-transparent">
              Servicios
            </span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto font-light">
            Ofrecemos una gama completa de tratamientos dentales con la más alta tecnología y especialistas certificados.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {services.map((svc, i) => (
            <div
              key={svc.title}
              className={`service-card bg-white rounded-3xl p-8 border border-gray-100 cursor-pointer scroll-animate anim-delay-${i * 100} group relative overflow-hidden`}
            >
              {/* Background accent on hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${svc.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-3xl`} />

              <div className="relative z-10">
                {/* Icon */}
                <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${svc.color} rounded-2xl mb-6 border border-white shadow-sm group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${svc.icon} ${svc.iconColor} text-3xl`} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-[#0A2540] mb-3 group-hover:text-[#3A86FF] transition-colors duration-200">
                  {svc.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {svc.desc}
                </p>

                {/* CTA link */}
                <div className="flex items-center gap-2 mt-5 text-[#3A86FF] text-sm font-semibold opacity-0 group-hover:opacity-100 transition-all duration-300 -translate-x-2 group-hover:translate-x-0">
                  <span>Saber más</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* Last card — CTA */}
          <div className="service-card bg-gradient-to-br from-[#0A2540] to-[#0d3060] rounded-3xl p-8 border border-[#3A86FF]/20 cursor-pointer scroll-animate anim-delay-500 flex flex-col justify-between">
            <div>
              <div className="w-16 h-16 flex items-center justify-center bg-[#3A86FF]/20 rounded-2xl mb-6">
                <i className="ri-question-answer-line text-[#3A86FF] text-3xl" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">¿No encuentras tu tratamiento?</h3>
              <p className="text-white/60 text-sm leading-relaxed">
                Contáctanos y un especialista te orientará sobre el tratamiento ideal para tu caso.
              </p>
            </div>
            <a
              href="tel:5534748982"
              className="mt-6 flex items-center gap-2 bg-[#3A86FF] hover:bg-[#1a6aff] text-white px-5 py-3 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors w-fit"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line" />
              </div>
              Llamar ahora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
